// 区域状态管理模块
const state = {
  // 当前区域状态管理
  currentRegion: {
    level: 'province', // 'province' | 'city'
    name: 'hunan', // 当前区域名称（拼音）
    mapName: '湖南省', // 当前区域中文名称
    adcode: '430000' // 当前区域代码
  }
}

const mutations = {
  // 设置当前区域状态
  SET_CURRENT_REGION(state, { level, name, mapName, adcode }) {
    state.currentRegion = {
      level: level || 'province',
      name: name || 'hunan',
      mapName: mapName || '湖南省',
      adcode: adcode || '430000'
    }
  },
  // 重置区域状态
  RESET_REGION(state) {
    state.currentRegion = {
      level: 'province',
      name: 'hunan',
      mapName: '湖南省',
      adcode: '430000'
    }
  }
}

const actions = {
  // 更新当前区域状态
  updateCurrentRegion({ commit }, { level, name, mapName, adcode }) {
    commit('SET_CURRENT_REGION', { level, name, mapName, adcode })
    
    // 将区域状态保存到localStorage以支持页面刷新后恢复
    try {
      const regionState = { level, name, mapName, adcode }
      localStorage.setItem('currentRegion', JSON.stringify(regionState))
    } catch (error) {
      console.warn('保存区域状态到localStorage失败:', error)
    }
  },
  // 从localStorage恢复区域状态
  restoreRegionFromStorage({ commit }) {
    try {
      const savedRegion = localStorage.getItem('currentRegion')
      if (savedRegion) {
        const regionState = JSON.parse(savedRegion)
        commit('SET_CURRENT_REGION', regionState)
        return regionState
      }
    } catch (error) {
      console.warn('从localStorage恢复区域状态失败:', error)
    }
    return null
  }
}

const getters = {
  currentRegion: state => state.currentRegion,
  currentRegionLevel: state => state.currentRegion.level,
  currentRegionName: state => state.currentRegion.name,
  currentRegionMapName: state => state.currentRegion.mapName,
  currentRegionAdcode: state => state.currentRegion.adcode,
  isProvinceLevel: state => state.currentRegion.level === 'province',
  isCityLevel: state => state.currentRegion.level === 'city'
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
